<script setup lang="ts">
const items = [
  {
    title: 'Follow-up Manual Makan Waktu',
    description: 'Harus chat satu per satu ke pembeli setiap kali ada update.',
    icon: 'material-symbols:mobile-camera-front-outline'
  },
  {
    title: 'Pelanggan Bingung Status Paket',
    description: 'Paket saya di mana ya?” jadi pertanyaan yang terus muncul.',
    icon: 'material-symbols:quiz-outline'
  },
  {
    title: 'Customer Service Kewalahan',
    description: 'Banyak pertanyaan berulang, bikin tim kelelahan',
    icon: 'material-symbols:support-agent'
  },
  {
    title: 'Gagal Kirim Karena Alamat Tidak Dikonfirmasi Cepat',
    description:
      'Padahal bisa diselesaikan kalau pembeli tahu status lebih cepat.',
    icon: 'material-symbols:sms-failed-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Kirim Barang itu Mudah, Tapi Menjaga Komunikasi itu Tantangan"
    hero-image="/images/wafu-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
